export default {
  labels: {
    selectOne: 'Wybierz jedną opcję',
    selectAll: 'Zaznacz wszystkie odpowiednie opcje',
    typeResponse: 'Wpisz swoją odpowiedź w poniższym polu tekstowym.',
    recordResponse: 'Nagraj odpowiedź, aby odpowiedzieć na pytanie.',
    enterNumeric: 'Wpisz odpowiedź numeryczną w poniższym polu.',
    rateResponseScale: 'Oceń swoją odpowiedź na podanej skali.',
    sliderMinimum: 'Wartość minimalna: {value}',
    sliderMaximum: 'Wartość maksymalna: {value}',
    selectOneOptionRow: 'Wybierz jedną opcję w każdym wierszu.',
    selectAllOptionsRow: 'Zaznacz wszystkie odpowiednie opcje w każdym wierszu.',
    dragAndDropResponse: 'Przeciągnij i upuść opcje, aby ustawić je według preferencji.',
    rankOrderDesktopInstruction: 'Przeciągnij i upuść elementy, aby je uszeregować, lub użyj przycisku +, aby dodać element. Użyj przycisków strzałek, aby zmienić kolejność, lub przycisku usuwania, aby usunąć element.',
    alert: "Uwaga",
    error: 'Wprowadź liczbę między {min} a {max}.',
    cameras: 'Kamery',
    microphones: 'Mikrofony',
    recording: 'Nagrywanie',
    noDevicesFound: 'Nie znaleziono urządzeń',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    stopRecording: 'Zatrzymaj nagrywanie',
    startRecording: 'Rozpocznij nagrywanie',
    disableCamera: 'Wyłącz kamerę',
    enableCamera: 'Włącz kamerę',
    disableMicrophone: 'Wyłącz mikrofon',
    enableMicrophone: 'Włącz mikrofon',
    settings: 'Ustawienia',
    recordingProgress: 'Postęp nagrywania',
    playbackProgress: 'Postęp odtwarzania',
    play: 'Odtwórz',
    pause: 'Wznów',
    stop: 'Zatrzymaj',
    record: 'Nagraj',
    recordAgain: 'Nagraj ponownie',
    retry: 'Spróbuj ponownie',
    done: 'Gotowe',
    minRecordTime: 'Proszę nagrać odpowiedź przez {min} sekund.',
    enlargeImage: 'Powiększ obraz',
    enlargedImage: 'Powiększony obraz',
    close: 'Zamknij',
    zoomIn: 'Powiększ',
    zoomOut: 'Pomniejsz',
    resetZoom: 'Zresetuj powiększenie',
    zoomLevel: 'Powiększenie {percentage}%',
    imagePosition: '{current} z {total}',
    previousImage: 'Poprzedni obraz',
    nextImage: 'Następny obraz',
    imageLoading: 'Wczytywanie obrazu',
    imageLoadFailed: 'Nie udało się wczytać obrazu',
  },
  noSelection: "Brak wyboru",
  actions: {
    increase: 'Zwiększ',
    decrease: 'Zmniejsz'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Podgląd Ankiety Zakończony',
      titleCompleted: 'Podgląd Ankiety Ukończony',
      previewModeWarning: 'Ta strona jest widoczna tylko w Trybie Podglądu i nie zostanie pokazana rzeczywistym respondentom.',
      reachedEndPoint: 'Ta ankieta osiągnęła punkt końcowy.',
      reachedEndPointCompleted: 'Ten podgląd osiągnął punkt końcowy.',
      returnToModify: 'Wróć do poprzedniego pytania, aby zmodyfikować odpowiedzi i przetestować inną ścieżkę ankiety.',
      logic: 'Logika'
    }
  }
}
